import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import TestTop from "./Pages/TestTop";
import Wizard from "./Pages/Wizard";
import About from "./Pages/About";
import ContactForm from "./Pages/ContactForm";
import BrandProducts from "./Pages/BrandProducts";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-blue-950">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<TestTop />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/brands/:brandSlug" element={<BrandProducts />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
